export const dadosMokadosTabela = {
  "paginas": 3,
  "pagina": 0,
  "colunas": [
    {
      "key": "checkbox",
      "titulo": "Checkbox",
      "esconder": false,
    },
    {
      "key": "descricao",
      "titulo": "Dados Mockados 1 ",
      "esconder": false,
    },
    {
      "key": "idImpressoraPadrao",
      "titulo": "Dados Mockados 2",
    },
    {
      "key": "versao",
      "titulo": "Dados Mockados 3",
    },
  ],
  "nodes": [
    {
      "id": 1031,
      "descricao": "Dados Mockados 11222",
      "idImpressoraPadrao": "Dados Mockados 450",
      "versao": 9,
    },
    {
      "id": 1022,
      "descricao": "Dados Mockados a",
      "idImpressoraPadrao": "Dados Mockados 391",
      "versao": 0,
    },
    {
      "id": 1023,
      "descricao": "Dados Mockados aa",
      "idImpressoraPadrao": "Dados Mockados 391",
      "versao": 0,
    },
    {
      "id": 984,
      "descricao": "Dados Mockados aaa",
      "idImpressoraPadrao": "Dados Mockados 906",
      "versao": 4,
    },
    {
      "id": 29,
      "descricao": "Dados Mockados BARa",
      "idImpressoraPadrao": "Dados Mockados316",
      "versao": 11,
    },
    {
      "id": 736,
      "descricao": "Dados Mockados BARNOTURNO",
      "idImpressoraPadrao": "Dados Mockados 845",
      "versao": 1,
    },
    {
      "id": 118,
      "descricao": "Dados Mockados CAIXA Editado",
      "idImpressoraPadrao": "Dados Mockados 579",
      "versao": 10,
    },
    {
      "id": 980,
      "descricao": "Dados Mockados CAIXASP",
      "idImpressoraPadrao": "Dados Mockados 391",
      "versao": 3,
    },
    {
      "id": 979,
      "descricao": "Dados Mockados COMPUTADOR TESTE",
      "idImpressoraPadrao": "Dados Mockados 1060",
      "versao": 1,
    },
    {
      "id": 30,
      "descricao": "Dados Mockados Cozinha",
      "idImpressoraPadrao": "Dados Mockados 880",
      "versao": 23,
    },
  ],
};

export const itensDiasDaSemana = [
  { displayValue: "Selecione", value: null },
  { displayValue: "Segunda-feira", value: "SEGUNDA" },
  { displayValue: "Terça-feira", value: "TERCA" },
  { displayValue: "Quarta-feira", value: "QUARTA" },
  { displayValue: "Quinta-feira", value: "QUINTA" },
  { displayValue: "Sexta-feira", value: "SEXTA" },
  { displayValue: "Sábado", value: "SABADO" },
  { displayValue: "Domingo", value: "DOMINGO" },
];
